@if (isImpersonating()) {
  @if (impersonatedUser(); as imp) {
    <div
      class="alert alert-warning rounded-0 border-0 py-2 mb-0 d-flex align-items-center justify-content-center gap-2 small w-100"
      role="alert"
      data-testid="app-impersonation-banner"
    >
      <i class="bi bi-person-fill-gear" aria-hidden="true"></i>
      <span>
        <span i18n="@@appImpersonationBannerLabel">Impersonating</span>
        <strong class="ms-1">{{ imp.name }}</strong>
        <span class="text-muted ms-1">({{ imp.email }})</span>
      </span>
    </div>
  }
}
<header>
  <abc-nav-bar />
</header>
<main>
  <router-outlet />
</main>
